<template>
  <div>
    <div
      v-for="(event, index) in parsedEvents"
      :key="index"
      class="timeline__item-container"
    >
      <div class="timeline__item">
        <div class="timeline__circle bg-info white">
          <i class="fa fa-exclamation" />
        </div>
  
        <div>
          <div class="m-b-3">
            <strong class="f-s-13">{{ event.displayName }}</strong>
          </div>
            
          <div :class="{ 'routing-plan-container': event.name === callPlanDetailEventName }">
            <div class="p-l-10 timeline__timestamp">
              <div
                class="generic-args"
              >
                <span
                  v-t="'CELL_BID_TIMESTAMP'"
                  class="generic-args__name overflow-ellipsis"
                />
    
                <span class="generic-args__value">
                  <TruncatedTextCopy
                    :copy-text="event.dateFormatted"
                  >
                    {{ event.dateFormatted }}
                  </TruncatedTextCopy>
                </span>
              </div>
            </div>
            
            <div
              v-for="(column, columnIndex) in event.columns"
              :key="columnIndex"
              class="p-l-10"
            >
              <div
                v-if="isGenericEventEntry(column.name)"
                class="generic-args"
              >
                <span
                  :title="column.displayName"
                  class="generic-args__name overflow-ellipsis"
                >
                  {{ column.displayName }}
                </span>
    
                <span class="generic-args__value">
                  <TruncatedTextCopy
                    :copy-text="column.formattedValue"
                  >
                    {{ column.formattedValue }}
                  </TruncatedTextCopy>
                </span>
              </div>
  
              <RoutingPlanDetail
                v-if="callPlanDetailEventNames[column.name]"
                :targets="column.formattedValue"
                :column-name="column.name"
                :column-display-name="column.displayName"
              />

              <PingTreePingingSummary 
                v-if="pingTreeSummaryEventNames[column.name]"
                :targets="column.formattedValue"
                :column-name="column.name"
                :column-display-name="column.displayName"
              />

              <RpcCalculationSummary 
                v-if="rpcCalculationSummaryEventNames[column.name]"
                :targets="column.formattedValue"
                :column-name="column.name"
                :column-display-name="column.displayName"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import messages from '../../../locales';
import sharedMessages from '@/core/locales';

import TruncatedTextCopy from '@/angularBridgeCode/components/TruncatedTextCopy';
import RoutingPlanDetail from '@/core/components/EventsLogDetail/RoutingPlanDetail';
import PingTreePingingSummary from '@/core/components/EventsLogDetail/PingTreePingingSummary';
import RpcCalculationSummary from '@/core/components/EventsLogDetail/RpcCalculationSummary';

export default {
  name: 'RtbEvents',
  components: {
    TruncatedTextCopy,
    RoutingPlanDetail,
    PingTreePingingSummary,
    RpcCalculationSummary
  },
  props: {
    parsedEvents: {
      type: Array,
      default: () => {
        return [];
      }
    },
  },
  data() {
    return {
      callPlanDetailEventNames: Object.freeze({
        'ineligibleTargets': true,
        'eligibleOrderedTargets': true
      }),
      rpcCalculationSummaryEventNames: Object.freeze({
        'duplicate': true,
        'errored': true,
        'calculated': true
      }),
      pingTreeSummaryEventNames: Object.freeze({
        'acceptedRingTreeTargets': true,
        'notAcceptedRingTreeTargets': true,
        'winningRingTreeTarget': true
      }),
    };
  },
  created() {
    this.callPlanDetailEventName = 'CallPlanDetail';
  },
  methods: {
    isGenericEventEntry(columnName) {
      return !this.callPlanDetailEventNames[columnName] && !this.rpcCalculationSummaryEventNames[columnName] && !this.pingTreeSummaryEventNames[columnName];
    },
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  }
};
</script>